import {escapeHTML} from "./escapeHTML";
import {Messages} from "../messages/Messages";
import {adaptErrors, Errors, FieldError, ObjectError} from "../dto/org.springframework.validation";
import {coalesce} from "./coalesce";
import {error} from "jquery";

const esc = escapeHTML;
const messages = new Messages();

interface RenderBaseParams {
	name?: string
	label?: string
	labelCode?: string
	labelClass?: string
	readonly?: boolean
	required?: boolean
	formErrors?: Errors
	formFieldErrors?: FieldError[]
	inert?: boolean
	placeholder?: any
	attributes?: any

	errorListClasses?: string
	helpDivClasses?: string
}

interface RenderSelectParams extends RenderBaseParams {
	optionContent: string
}

interface RenderInputParams extends RenderBaseParams {
	value?: string
}

interface RenderNumberParams extends RenderBaseParams {
	value?: string | number | null
	step?: string | number
	min?: string | number
}

interface HorizontalFormItemParams {
	labelWidth: number
}

export function springErrorList(errors: ObjectError[], errorListClasses = 'list-unstyled invalid-feedback') {
	if (errors.length == 0)
		return '';
	return `<ul class="${errorListClasses}">` + errors.map(e => `<li>${escapeHTML(e.message)}</li>`) + '</ul>'
}

function prepareInput(params: RenderNumberParams) {
	const name = coalesce(params.name, '')
	const placeholder = coalesce(params.placeholder, '');

	const errors = coalesce(params.formFieldErrors, name.length > 0 ? adaptErrors(params.formErrors).getFieldErrors(name) : []);
	const labelClass = params.labelClass ? `${params.labelClass}` : ''
	const label = coalesce(params.label, messages.get(coalesce(params.labelCode, name)));
	const inputClass = `${errors.length > 0 ? ' is-invalid' : ''}`

	const value = typeof params.value === 'undefined' || params.value === null ? '' : params.value;
	const stepAttribute = typeof params.step === 'undefined' || params.step === null ? '' : `step="${params.step}"`;
	const minAttribute = typeof params.min === 'undefined' || params.min === null ? '' : `min="${params.min}"`;

	let tail = springErrorList(errors, params.errorListClasses)
	if (tail.length == 0) {
		const helpMessageCode = params.labelCode + 'Help'
		const helpMessage = messages.has(helpMessageCode) ? messages.get(helpMessageCode) : null;
		if (helpMessage != null && helpMessage.length > 0) {
			const helpIdAttribute = name.length == 0 ? '' : `id="${name}Help"`
			tail += `<div ${helpIdAttribute} class="form-text ${coalesce(params.helpDivClasses, '')}">${escapeHTML(helpMessage)}</div>`;
		}
	}

	const idAttribute = name.length == 0 ? '' : `id="${name}"`
	const nameAttribute = name.length == 0 ? '' : `name="${name}"`
	const ariaDescribedby = name.length == 0 ? '' : `aria-describedby="${name}Help"`
	const placeholderAttribute = placeholder.length == 0 ? '' : `placeholder="${esc(placeholder)}"`;
	return {name, nameAttribute, inputClass, label, labelClass, idAttribute, ariaDescribedby, placeholderAttribute, value, stepAttribute, minAttribute, tail}
}

export function springSelect(params: RenderSelectParams) {
	const options = prepareInput(params);

	return `
<label for="${params.name}" class="form-label ${options.labelClass}">${esc(options.label)}</label>
<select class="form-select ${options.inputClass}" "${options.idAttribute}" ${options.ariaDescribedby} ${options.placeholderAttribute}
        ${options.nameAttribute} ${params.readonly ? 'readonly ' : ' '} ${params.required ? 'required ' : ' '} ${params.attributes}>${params.optionContent}</select>
    ` + options.tail;
}

export function springNumber(params: RenderNumberParams) {
	const options = prepareInput(params);
	return `
<label for="${params.name}" class="form-label ${options.labelClass}">${esc(options.label)}</label>
<input type="number" lang="en" class="form-control ${options.inputClass}" ${options.idAttribute} ${options.ariaDescribedby} ${options.placeholderAttribute}
        ${options.nameAttribute} ${params.readonly ? 'readonly ' : ' '} ${params.required ? 'required ' : ' '} value="${esc(options.value)}" ${options.stepAttribute} ${options.minAttribute}>
    ` + options.tail;
}

export function springHorizontalNumber(params: RenderNumberParams & HorizontalFormItemParams) {
	const options = prepareInput({
		...params,
		errorListClasses: 'list-unstyled invalid-feedback d-block col-12 text-end',
		helpDivClasses: 'col-12'
	});
	return `
<label for="${params.name}" class="col-sm-${params.labelWidth} col-form-label ${options.labelClass}">${esc(esc(options.label))}</label>
<div class="col-sm-${12 - params.labelWidth}">
	<input lang="en" type="number" class="form-control ${options.inputClass}" ${options.idAttribute} ${options.ariaDescribedby} ${options.placeholderAttribute}  ${options.nameAttribute} 
		   value="${esc(options.value)}" ${params.readonly ? 'readonly ' : ' '} ${params.required ? 'required ' : ' '} ${options.stepAttribute} ${options.minAttribute}>
</div>
    ` + options.tail;
}

export function springText(params: RenderInputParams) {
	const options = prepareInput(params);
	return `
<label for="${params.name}" class="form-label ${options.labelClass}">${esc(options.label)}</label>
<input type="text" class="form-control ${options.inputClass}" ${options.idAttribute} ${options.ariaDescribedby} ${options.placeholderAttribute}
          ${options.nameAttribute} ${params.readonly ? 'readonly ' : ' '} ${params.inert ? 'inert' : ''} ${params.required ? 'required ' : ' '} value="${esc(options.value)}">
    ` + options.tail;
}